import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useState, useRef } from 'react';
import { Steps } from "primereact/steps";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import FormCrearSubproductoFicha from "./FormCrearSubproductoFicha";

const FormCrearSubproducto = ({
    displayDialog,
    setDisplayDialog,
    subproducto,
    setSubproducto,
    handleCreateSubproducto,
    unidad,
    setUnidad,
    tarifa,
    setTarifa,
    baseUrl
}) => {
    const [activeStep, setActiveStep] = useState(0);
    const stepsItems = [{ label: "Subproducto", command: () => setActiveStep(0) },{ label: "Ficha técnica", command: () => setActiveStep(1) },];
    const handleStepChange = (e) => {setActiveStep(e.index);};
    const [unidades] = useState([{ label: "Metro cuadrado (m²)", value: "m**2" }]);
    const fichaRef = useRef(null);
    const [perfil] = useState("");
    const [ficha] = useState("");
    const limpiarFormulario = () => {
        setSubproducto({descripcion: ""});
        setUnidad("");
        setTarifa("");
        setDisplayDialog(false);
    };
    // Función para manejar la creación del subproducto
    const handleCrearSubproducto = async () => {
        try {
            // Capturar datos de la ficha ANTES de que el componente se desmonte por el loading
            let fichaData = null;
            if (fichaRef.current) {
                fichaData = fichaRef.current.getData();
            }

            // Llamar a la función original de crear subproducto
            const resultado = await handleCreateSubproducto();
            if (resultado && resultado.subproducto && resultado.subproducto.id) {
                const idSubproducto = resultado.subproducto.id;
                // Llamar a la función para crear la ficha técnica con el ID del subproducto y los datos capturados
                await handleCrearSubproductoFicha(idSubproducto, fichaData);
                // Cerrar el diálogo después de crear el subproducto y la ficha técnica
                setDisplayDialog(false);
            }
        } catch (error) {
            console.error("Error al crear producto:", error);
        }
    };

    const handleCrearSubproductoFicha = async (idSubproducto, fichaData) => {
        try {
            if (fichaData) {
                const body = {
                    idSubproducto: idSubproducto,
                    perfil: fichaData.perfil,
                    ficha: fichaData.fichaJson
                };
    
                const resp = await fetch(`${baseUrl}/createSubproductoFicha`, {
                    method: "POST",
                    headers: { 
                        "Content-Type": "application/json; charset=UTF-8"
                    },
                    body: JSON.stringify(body),
                });
                
                return resp.ok;
            }
        } catch (error) {
            console.error("Error al crear ficha técnica:", error);
            return false;
        }
    };

    const footerCrearProd = () => {
        return (
            <div className="p-d-flex p-jc-end p-mt-3">
                <Button
                    label="Cancelar"
                    icon="pi pi-times"
                    onClick={limpiarFormulario}
                    className="p-button p-mr-2 p-button-outlined p-button-rounded"
                />
                <Button
                    label="Guardar"
                    icon="pi pi-save"
                    onClick={handleCrearSubproducto}
                    className="p-button-success p-button-rounded p-button"
                    raised
                    autoFocus
                    disabled={!(subproducto.descripcion && unidad && tarifa)}
                />
            </div>
        );
    };

    return (
        <div className="form-container">
            <Dialog
                visible={displayDialog}
                className="p-fluid product-dialog"
                onHide={limpiarFormulario}
                footer={footerCrearProd()}
                header="Crear Tipo de Subproducto"
            >

                <Steps 
                    model={stepsItems} 
                    activeIndex={activeStep} 
                    onSelect={handleStepChange}
                    className="cursor-pointer"
                    style={{ cursor: 'pointer' }}
                    readOnly={false}
                />
                
                <div className="card" style={{ display: activeStep === 0 ? 'block' : 'none' }}>
                        <h6 className="mb-3">
                            Información del Subproducto
                        </h6>

                        <span className="p-float-label mt-2 mb-3">
                            <InputText
                                id="descripcion"
                                value={subproducto.descripcion}
                                onChange={(e) =>
                                    setSubproducto({
                                        ...subproducto,
                                        descripcion: e.target.value.toUpperCase(),
                                    })
                                }
                                className="p-inputtext-lg"
                                placeholder="Ingrese la descripción del subproducto"
                                required
                                max={35}
                            />
                            <label htmlFor="descripcion">
                                <i className="pi pi-file-edit mr-2"></i>Descripción *
                            </label>
                        </span>

                        <span className="p-float-label mt-2 mb-3">
                            <Dropdown
                            id="unidad"
                            value={unidad}
                            options={unidades}
                            onChange={(e) => setUnidad(e.value)}
                            placeholder="Seleccione una unidad"
                            optionLabel="label"
                            className="p-inputtext-lg"
                            />
                            <label htmlFor="unidad"><i className="pi pi-cog"></i> Unidad*</label>
                        </span>
                        <span className="p-float-label mt-2 mb-3">
                            <InputNumber
                            id="tarifa"
                            value={tarifa}
                            onValueChange={(e) => setTarifa(e.value)} // Handle value change
                            mode="decimal" // Handle decimal numbers
                            minFractionDigits={0} // Set minimum number of decimal digits
                            maxFractionDigits={2} // Set maximum number of decimal digits
                            placeholder="Ingrese la tarifa en UF"
                            className="p-inputtext-lg"
                            locale="es-ES" // Set locale to use comma for decimal
                            inputMode="decimal" // HTML5 input mode for numeric decima
                            min={0.01}
                            max={1000}
                            />
                            <label htmlFor="tarifa"><i className="pi pi-money-bill"></i> Tarifa UF*</label>
                        </span>

                        {/* Navegación entre steps */}
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button label="" rounded outlined icon="pi pi-arrow-right" iconPos="right" className="" onClick={() => setActiveStep(1)}/>
                        </div>
                    </div>

                    <div className="card" style={{ display: activeStep === 1 ? 'block' : 'none' }}>
                        <FormCrearSubproductoFicha
                            ref={fichaRef}
                            perfil={perfil}
                            ficha={ficha}
                        />
                        <div className="flex-space-between">
                            <Button label="" icon="pi pi-arrow-left" rounded outlined onClick={() => setActiveStep(0)} />
                        </div>
                    </div>
            </Dialog>
        </div>
    );
};

export default FormCrearSubproducto;
